import React from 'react'
import TermsConditions from '../components/TermsConditions'
import Layout from '../components/Layout'

function TermsPage() {
  return <Layout noHeader noFooter noMoku><TermsConditions /></Layout>
}

export default TermsPage